import { AppStateCreator, InventorySlice } from '../types';
import {  initialState } from './index';

export const createInventorySlice: AppStateCreator<InventorySlice> = (set) => ({
  inventories: {
    ...initialState.inventories,
    setFilters: (newFilters) => {
      set((state) => ({
        inventories: {
          ...state.inventories,
          filters: { ...state.inventories.filters, ...newFilters },
        },
      }));
    },
    openImageCaptureModal: () => {
      set((state) => ({
        inventories: {
          ...state.inventories,
          modals: {
            ...state.inventories.modals, 
            isImageCaptureOpen: true
          }
        }
      }));
    },
    closeImageCaptureModal: () => {
      set((state) => ({
        inventories: {
          ...state.inventories,
          modals: {
            ...state.inventories.modals, 
            isImageCaptureOpen: false
          }
        }
      }));
    },
    openChangeStatusModal: () => {
      set((state) => ({
        inventories: {
          ...state.inventories,
          modals: {
            ...state.inventories.modals, 
            isChangeStatusVehiclesOpen: true
          }
        }
      }));
    },
    closeChangeStatusModal: () => {
      set((state) => ({
        inventories: {
          ...state.inventories,
          modals: {
            ...state.inventories.modals, 
            isChangeStatusVehiclesOpen: false
          }
        }
      }));
    },
    setIsConvertingImagesToText: (value) => {
      set((state) => ({
        inventories: {
          ...state.inventories,
          isConvertingImagesToText: value,
        },
      }));
    },
    setLicensePlates: (plates) => {
      set((state) => ({
        inventories: {
          ...state.inventories,
          licensePlates: plates,
        },
      }));
    },
    setSucessProcessImages: (value) => {
      set((state) => ({
        inventories: {
          ...state.inventories,
          sucessProcessImages: value,
        },
      }));
    },
  }
})
